import { render, staticRenderFns } from "./AddEditSFDALabs.vue?vue&type=template&id=b6a42640&scoped=true"
import script from "./AddEditSFDALabs.vue?vue&type=script&lang=js"
export * from "./AddEditSFDALabs.vue?vue&type=script&lang=js"
import style0 from "./AddEditSFDALabs.vue?vue&type=style&index=0&id=b6a42640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a42640",
  null
  
)

export default component.exports